import { MainLayout } from 'Components/Layouts'
import { SuspenseUI } from 'Components/UI'
import { SchoolPath } from 'Constants/Navigation'
import { SchoolAnnouncementDetailPage } from 'Views/SchoolAnnouncements/Pages/SchoolAnnouncementDetail'
import { SchoolAnnouncementsPage } from 'Views/SchoolAnnouncements/Pages/SchoolAnnouncements'
import { Navigate } from 'react-router-dom'

export const schoolRoutes = {
  path: '',
  children: [
    {
      path: `/${SchoolPath.main}`,
      element: <MainLayout />,
      children: [
        {
          path: '',
          element: <Navigate to={`/${SchoolPath.main}/${SchoolPath.announcements}`} replace />,
        },
        {
          path: SchoolPath.announcements,
          element: (
            <SuspenseUI>
              <SchoolAnnouncementsPage />
            </SuspenseUI>
          ),
        },
        {
          path: `${SchoolPath.announcements}/:announcementId`,
          element: (
            <SuspenseUI>
              <SchoolAnnouncementDetailPage />
            </SuspenseUI>
          ),
        },
      ],
    },
  ],
}
